import {Guid} from './Guid';

export class BaseIdQuery {
  Id: string;

  static Columns() {
    return ['Id'];
  }

  static getDisplayName(values: string[]) {
    const withValues = Array.from(new Set(values.filter(value => !!value)));
    let name = '';
    for (let i = 0; i < withValues.length; i++) {
      name += withValues[i];
      if (i === 0 && withValues.length > 1) {
        name += ': ';
      } else if (withValues.length > i && i !== withValues.length - 1) {
        name += ', ';
      }
    }
    return name;
  }

  constructor() {
    this.Id = Guid.create();
  }
}

export class BaseIdCodeQuery extends BaseIdQuery {
  Code: string;

  static Columns() {
    return [...BaseIdQuery.Columns(), 'Code'];
  }

  get DisplayName(): string {
    return this._displayName ?? BaseIdQuery.getDisplayName([this.Code]);
  }
  set DisplayName(value: string) {
    this._displayName = value;
  }
  protected _displayName?: string;
}

export class IdTextQuery extends BaseIdQuery {
  Text: string;

  static Columns() {
    return [...BaseIdQuery.Columns(), 'Text'];
  }
}

export class IdCodeNameQuery extends BaseIdCodeQuery {
  Name: string;

  constructor(init?: Partial<IdCodeNameQuery>) {
    super();
    Object.assign(this, init);
  }

  static Columns() {
    return [...BaseIdCodeQuery.Columns(), 'Name'];
  }

  get DisplayName(): string {
    return this.getDisplayName();
  }
  set DisplayName(value: string) {
    this._displayName = value;
  }

  getDisplayName(nameOnly: boolean = false){
    return this._displayName ?? BaseIdQuery.getDisplayName([nameOnly ? null : this.Code, this.Name]);
  }
}
